import {Popover, Portal, Transition} from "@headlessui/react";
import {Fragment, useEffect, useRef, useState} from "react";
import classNames from "classnames";
import {buildAppleMapsUrl, buildGoogleMapsUrl, formatAddress} from "@autocx/forms/src/controls/address";

export default function LocationAddress({location}) {
    const buttonRef = useRef(null);
    const [coords, setCoords] = useState({top: 0, left: 0});
    const [isOpen, setIsOpen] = useState(false);

    // Recalculate position when popover opens
    useEffect(() => {
        if (isOpen && buttonRef.current) {
            const rect = buttonRef.current.getBoundingClientRect();
            setCoords({
                top: rect.bottom + window.scrollY,
                left: rect.left + window.scrollX
            });
        }
    }, [isOpen]);

    return (
        <>
            <div data-address="" className="items-center space-x-2 hidden sm:flex">
                <svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" className="w-5 h-5">
                    <g transform="translate(0, 1)">
                        <path
                            d="M12 1.5c-4.14 0-7.5 3.024-7.5 6.75 0 6 7.5 14.25 7.5 14.25s7.5-8.25 7.5-14.25c0-3.726-3.36-6.75-7.5-6.75ZM12 12a3 3 0 1 1 0-5.999A3 3 0 0 1 12 12Z"/>
                    </g>
                </svg>
                <a href={buildGoogleMapsUrl(location.address)}
                   target="_blank" rel="noreferrer">
                    {formatAddress(location.address, true)}
                </a>
            </div>

            <Popover className="sm:hidden">
                {({open}) => {
                    useEffect(() => {
                        setIsOpen(open);
                    }, [open]);

                    return (
                        <>
                            <Popover.Button
                                ref={buttonRef}
                                className="font-bold flex flex-row gap-1.5 items-center outline-none"
                                data-address=""
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" width="17" height="15"
                                     viewBox="0 0 17 15">
                                    <path fill="currentColor" fillRule="evenodd"
                                          d="M1096.94986,555.540929 L1096.94986,557.665665 L1092.37846,557.665665 C1089.14305,557.665665 1087.6139,559.210928 1087.6139,562.430225 L1087.6139,566.663647 C1087.6139,567.613263 1088.08069,568.176769 1088.94989,568.160492 C1089.78691,568.144421 1090.28591,567.613263 1090.28591,566.663647 L1090.28591,562.558997 C1090.28591,561.062029 1090.99415,560.353784 1092.41064,560.353784 L1096.94986,560.353784 L1096.94986,562.494611 C1096.94986,563.573081 1098.06043,564.039874 1098.91362,563.379923 L1102.84127,560.32158 C1103.87144,559.500654 1103.87144,558.518774 1102.84127,557.697848 L1098.91362,554.655617 C1098.06043,553.995666 1096.94986,554.462459 1096.94986,555.540929 Z"
                                          transform="translate(-1087 -554)"/>
                                </svg>
                                <span>Directions</span>
                            </Popover.Button>

                            <Portal>
                                <Transition
                                    as={Fragment}
                                    enter="transition ease-in duration-100 origin-top-left"
                                    enterFrom="opacity-0 scale-95"
                                    enterTo="opacity-100 scale-100"
                                    leave="transition ease-out duration-100 origin-top-left"
                                    leaveFrom="opacity-100 scale-100"
                                    leaveTo="opacity-0 scale-95"
                                >
                                    <Popover.Panel
                                        static
                                        className={classNames(
                                            "popover-panel space-y-1 flex flex-col w-44 z-50 px-4 py-2 shadow-[0_2px_6px_-4px_rgba(0,0,0,0.3),0px_10px_20px_-15px_rgba(0,0,0,0.2)] section-white"
                                        )}
                                        style={{
                                            position: "absolute",
                                            top: coords.top,
                                            left: coords.left,
                                            borderRadius: "var(--container-roundness)"
                                        }}
                                    >
                                        {({close}) => (
                                            <div className="flex flex-col space-y-2">
                                                <div className="flex flex-col">
                                                    <button
                                                        className="text-left"
                                                        onClick={() => {
                                                            navigator.clipboard.writeText(
                                                                formatAddress(location.address, true)
                                                            );
                                                            close();
                                                        }}
                                                    >
                                                        Copy Address
                                                    </button>
                                                </div>
                                                <div className="flex flex-col">
                                                    <a
                                                        href={buildAppleMapsUrl(location.address)}
                                                        target="_blank" rel="noreferrer"
                                                    >
                                                        Apple Maps
                                                    </a>
                                                </div>
                                                <div className="flex flex-col">
                                                    <a
                                                        href={buildGoogleMapsUrl(location.address)}
                                                        target="_blank" rel="noreferrer"
                                                    >
                                                        Google Maps
                                                    </a>
                                                </div>
                                            </div>
                                        )}
                                    </Popover.Panel>
                                </Transition>
                            </Portal>
                        </>
                    );
                }}
            </Popover>
        </>
    );
}